import * as React from 'react';
import styled from 'styled-components';
import { Layout, Form, Button, Descriptions } from 'antd';
import { VMFullWithButton, FullWithButton } from 'components/Forms/Form.Styled';

export const singleColFormColSize = {
  labelCol: {
    xs: { span: 9 },
    md: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 14 },
    md: { span: 17 },
  },
};

export const IPOTitle = styled.h1`
  font-size: 3em;
  font-weight: bold;
  color: #202020;
`;

export const BorderlessDescriptions = styled(Descriptions)`
  .ant-descriptions-row {
    font-size: 1.3em;
    .ant-descriptions-item.flexed {
      display: flex;
      > *:first-child {
        flex-grow: 1;
      }
      > *:last-child {
        flex-grow: 3;
        align-self: flex-end;
      }
    }
    .ant-descriptions-item-label {
      background-color: transparent;
      padding: 5px 3px;

      font-weight: 400;
    }
  }
`;

export const IPOImage = styled.img`
  max-width: 300px;
  max-height: 150px;
  margin-bottom: 10px;
  /* box-shadow: 8px 0px 20px 0px rgba(0, 0, 0, 0.48); */
`;
export const ProspectusLink = styled(FullWithButton)`
  margin-top: 10px;
  margin-bottom: 5px;
  padding: 0px;
  color: #F0403D;
  font-weight: bolder;
  font-size: 1.6em;
`;

export const GeneralApplyNowLink = styled(VMFullWithButton)`
  background-color: #F0403D;
  color: white;
  &:hover,
  &:focus {
    background-color: #F0403D;
    color: white;
  }
`;
